import React, { useEffect, useMemo, useState } from "react";
import { Space, Tabs } from "antd";
import { CaretRightOutlined, CaretUpOutlined, EyeOutlined, PlusCircleOutlined, SettingOutlined } from "@ant-design/icons";
import { FlattenedField } from "../../../CustomersV2/indexV2";
import { FieldsUpdate, getInfoVehicleOwnership, getListCustomerInsurance, getListCustomerInteractions, getListCustomerInvoices, getListCustomerRepair, getListFieldsByCustomer, ICustomer, ICustomerRepair, InfoVehicleOwnership, IVehicleInterestContactHistory, ListField, updateFieldUser } from "../../../../api/Customer_V2/customerApi_V2";
import { ColumnKey } from "../../../Customers/Tabs/CarListCardClone";

import { VehicleVersionTable } from "../VehicleVersionTable";
import { AppRowCar, buildViewRowsCar, kCity, kRole, makeColumnsCar } from "../VehicleVersionTable/fn";
import ContactInformation from "../ServiceRecords/ContactInformation";
import WarrantyInformation from "../ServiceRecords/WarrantyInformation";
import MaintenanceHistory from "../ServiceRecords/MaintenanceHistory";
import VehicleContactHistory from "../ServiceRecords/VehicleContactHistory";
import useDebounce from "../../../../hook/useDebounce";
import useLoading from "../../../../hook/useLoading";
import useToast from "../../../../hook/useToast";
import { selectorCategoryCarIds } from "../../../../store/slices/categoryCarSlice";
import { useSelector } from "react-redux";
import { selectorInfoUser } from "../../../../store/slices/infoUserSlice";
import { IPagination } from "../../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup";
import { PaginationProps } from "antd/lib";
import CarFeilds from "./CarFeilds";
import '../../styles.scss'
import ServiceRecordFeilds from "../ServiceRecords/Components/ServiceRecordFeilds";
// import ModalUpdateVehicleInformation from "../../../CustomerDetailsCleanedV2/components/ModalUpdateVehicleInformation";
import { FIELDTYPE } from "../../../../services/data";
import useThrottle from "../../../../hook/useThrottle";
import { flattenFields, getUserPermissions } from "../../../../until";
import ModalUpdateVehicleInformation from "./ModalCar/ModalUpdateVehicleInformation";
import { IDataDefaulFilterList } from "../VehicleVersionTable/Modal/FilterHeaderVehicleVersionTable";
import { selectorPermission } from "../../../../store/slices/permissionSlice";


interface IDataFilterActive {
    invoices: FlattenedField[];
    insurance: FlattenedField[];
    maintenanceHistory: FlattenedField[];
    contactHistory: FlattenedField[];
}

interface IDataFilterNoActive {
    invoices: ListField[];
    insurance: ListField[];
    maintenanceHistory: ListField[];
    contactHistory: ListField[];
}

const EMPTY_GROUP = {
    invoices: [],
    insurance: [],
    maintenanceHistory: [],
    contactHistory: [],
};

type PaginationKey = "invoices" | "insurance" | "maintenanceHistory" | "contactHistory";

interface Props {
    loadingTable: boolean
    isModalUpdateVehicleInformation: boolean
    dataFilterActive: FlattenedField[]
    dataFilterList?: IDataDefaulFilterList

    idCustomer?: number
    listVehicle: ICustomer[]
    setDataFilterList?: (dataFilterList: IDataDefaulFilterList) => void
    setIsModalUpdateVehicleInformation: (e: boolean) => void
    resultFormSubmitOwnedCarOrUsedCar?: (iSsuccess: boolean, message?: string) => void
}

const OwnedCar: React.FC<Props> = ({
    loadingTable,
    isModalUpdateVehicleInformation,
    dataFilterActive, dataFilterList,
    idCustomer, listVehicle,
    setDataFilterList,
    setIsModalUpdateVehicleInformation, resultFormSubmitOwnedCarOrUsedCar
}) => {
    const pushLoading = useLoading()
    const pushToast = useToast();
    const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)
    const { id, unitTemp } = useSelector(selectorInfoUser) // đợn vị dc chọn

    useEffect(() => {
        gListFieldsActive()
    }, [])

    const [isSettingShow, setSettingShow] = useState(false)
    const [openModal, setOpenModal] = useState<boolean>(false)


    const permissionSlice = useSelector(selectorPermission)
    const { access, edit } = getUserPermissions(permissionSlice, location.pathname)


    const [loadingTableDetail, setLoadingTableDetail] = useState(false)


    const [activeServiceRecordsTab, setActiveServiceRecordsTab] = useState<PaginationKey>("invoices");
    const [dataFieldsServiceRecordsActive, setDataFieldsServiceRecordsActive] = useState<IDataFilterActive>(EMPTY_GROUP);
    const [dataFieldsServiceRecordsNoActive, setDataFieldsServiceRecordsNoActive] = useState<IDataFilterNoActive>(EMPTY_GROUP);
    const [columnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([]);

    const [paginationMap, setPaginationMap] = useState<Record<PaginationKey, IPagination>>({
        invoices: { current: 1, pageSize: 10, total: 0 },
        insurance: { current: 1, pageSize: 10, total: 0 },
        maintenanceHistory: { current: 1, pageSize: 10, total: 0 },
        contactHistory: { current: 1, pageSize: 10, total: 0 },
    });

    const [loadedTabs, setLoadedTabs] = useState({
        invoices: false,
        insurance: false,
        maintenanceHistory: false,
        contactHistory: false,
    });

    const currentLoaded = loadedTabs[activeServiceRecordsTab];

    const [selectedIdTable, setSelectedIdTable] = useState<number>();
    // const [selectedId, setSelectedId] = useState<number>();
    // const [customerCodeDms, setCustomerCodeDms] = useState<string>();
    const [row, setRow] = useState<AppRowCar>();

    const [invoicesInfo, setInvoicesInfo] = useState<ICustomer[]>([]);

    
    const [insuranceInfo, setInsuranceInfo] = useState<ICustomer[]>([]);
    const [maintenanceHistory, setMaintenanceHistory] = useState<ICustomerRepair>();
    const [contactHistory, setContactHistory] = useState<IVehicleInterestContactHistory>();

    const [infoVehicleOwnership, setInfoVehicleOwnership] = useState<InfoVehicleOwnership>();


    // #region Modal
    const handleOpenModal = (type: string, id: number) => {
        switch (type) {
            case 'update':
                if (!idCustomer) return
                // sai id, id của row chứ k phải id xe
                gInfoVehicleOwnership(idCustomer, id)

                break;

            default:
                break;
        }
    }


    //#region Cấu hình VehicleVersionTable
    const filterColumn = ['nameCar', 'year', 'price', "own_vehicle_status"];
    // expanded set
    const [expanded, setExpanded] = React.useState<Set<string>>(new Set());

    // Build rows từ dataCarTest
    const viewRowsCar = useMemo(() =>
        buildViewRowsCar(listVehicle, expanded)
        , [expanded, listVehicle]);

    // Toggle expand
    const toggleCarType = React.useCallback((carType: string) => {
        setExpanded((prev) => {
            const next = new Set(prev);
            const key = kCity(carType);
            next.has(key) ? next.delete(key) : next.add(key);
            return next;
        });
    }, []);

    const toggleBrand = React.useCallback((carType: string, brand: string) => {
        setExpanded((prev) => {
            const next = new Set(prev);
            const key = kRole(carType, brand);
            next.has(key) ? next.delete(key) : next.add(key);
            return next;
        });
    }, []);

    // Columns (tĩnh + động)
    const columnsCar = useMemo(
        () => makeColumnsCar(
            expanded, access, edit, toggleCarType, toggleBrand,
            dataFilterActive, handleOpenModal, idCustomer, ["own_representative"],
            permittedCategoryCarIds
        ),
        [expanded, toggleCarType, toggleBrand, columnsMapShow, idCustomer, permittedCategoryCarIds]
    );

    // Đồng bộ columnsMapShow từ cấu hình active
    useEffect(() => {
        const codes = dataFilterActive.map((f) => f.fieldCode) as ColumnKey[];
        setColumnsMapShow(codes);
    }, [dataFilterActive]);

    //#endregion

    const gListFieldsActive = async () => {
        const [contactInformationRes, warrantyInformationRes, maintenanceHistoryRes, vehicleContactHistoryRes] =
            await Promise.all([
                getListFieldsByCustomer(FIELDTYPE.invoices, 1),
                getListFieldsByCustomer(FIELDTYPE.insurance, 1),
                getListFieldsByCustomer(FIELDTYPE.maintenanceHistory, 1),
                getListFieldsByCustomer(FIELDTYPE.contactHistoryByOwnedCar, 1),
            ]);

        const flattenedFieldsContactInformation = flattenFields(contactInformationRes?.data ?? []);
        const flattenedFieldsWarrantyInformation = flattenFields(warrantyInformationRes?.data ?? []);
        const flattenedFieldsMaintenanceHistory = flattenFields(maintenanceHistoryRes?.data ?? []);
        const flattenedFieldsVehicleContactHistory = flattenFields(vehicleContactHistoryRes?.data ?? []);

        setDataFieldsServiceRecordsActive({
            invoices: flattenedFieldsContactInformation,
            insurance: flattenedFieldsWarrantyInformation,
            maintenanceHistory: flattenedFieldsMaintenanceHistory,
            contactHistory: flattenedFieldsVehicleContactHistory,
        });

        gListFieldsNotActive();
    };

    const gListFieldsNotActive = async () => {
        const [contactInformationNoActiveRes, warrantyInformationNoActiveRes, maintenanceHistoryNoActiveRes, vehicleContactHistoryNoActiveRes] =
            await Promise.all([
                getListFieldsByCustomer(FIELDTYPE.invoices, 0),
                getListFieldsByCustomer(FIELDTYPE.insurance, 0),
                getListFieldsByCustomer(FIELDTYPE.maintenanceHistory, 0),
                getListFieldsByCustomer(FIELDTYPE.contactHistoryByOwnedCar, 0),
            ]);

        setDataFieldsServiceRecordsNoActive({
            invoices: contactInformationNoActiveRes?.data ?? [],
            insurance: warrantyInformationNoActiveRes?.data ?? [],
            maintenanceHistory: maintenanceHistoryNoActiveRes?.data ?? [],
            contactHistory: vehicleContactHistoryNoActiveRes?.data ?? []
        })
    };

    const gListCustomerInvoices = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
        const selectedId = row?.idCover ? Number(row.idCover) : undefined;
        if (!idCustomer || !selectedId) {
            setInvoicesInfo([])
            return;
        }
        setLoadingTableDetail(true)
        const result = await getListCustomerInvoices(
            idCustomer, selectedId, unitTemp, permittedCategoryCarIds,
            pageSize, pageCurent
        )
        if (result?.status) {
            setInvoicesInfo(result.data)
            setPaginationMap(prev => ({
                ...prev,
                invoices: {
                    current: pageCurent,
                    pageSize,
                    total: result.total,
                },
            }));
        } else {
            pushToast(result?.message, "warning")
        }
        // 🔥 QUAN TRỌNG
        setLoadedTabs(prev => ({
            ...prev,
            invoices: true,
        }));
        setLoadingTableDetail(false)
    }, 1000)

    // bảo hiểm
    const gListCustomerInsurance = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
        const selectedId = row?.idCover ? Number(row.idCover) : undefined;

        if (!idCustomer || !selectedId) {
            setInsuranceInfo([])
            return;
        }
        setLoadingTableDetail(true)
        const result = await getListCustomerInsurance(
            idCustomer, selectedId, unitTemp, permittedCategoryCarIds,
            pageSize, pageCurent
        )
        if (result?.status) {
            setInsuranceInfo(result.data)
            setPaginationMap(prev => ({
                ...prev,
                insurance: {
                    current: pageCurent,
                    pageSize,
                    total: result.total,
                },
            }));
        } else {
            pushToast(result?.message, "warning")
        }

        // 🔥 QUAN TRỌNG
        setLoadedTabs(prev => ({
            ...prev,
            insurance: true,
        }));
        setLoadingTableDetail(false)
    }, 1000)

    // bảo trì bảo dưỡng
    const gListCustomerRepair = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
        const selectedId = row?.idCover ? Number(row.idCover) : undefined;


        if (!idCustomer || !selectedId) {
            setMaintenanceHistory(undefined)
            return;
        }
        setLoadingTableDetail(true)
        
    // Xe sử dụng truyền type = 14 để phân biệt với se sở hữ bằng 7
        const result = await getListCustomerRepair(
            idCustomer, selectedId, unitTemp, permittedCategoryCarIds,
            pageSize, pageCurent, 7
        )
        if (result?.status) {
            setMaintenanceHistory(result.data)
            setPaginationMap(prev => ({
                ...prev,
                maintenance: {
                    current: pageCurent,
                    pageSize,
                    total: result.total,
                },
            }));
        } else {
            pushToast(result?.message, "warning")
        }
        // 🔥 QUAN TRỌNG
        setLoadedTabs(prev => ({
            ...prev,
            maintenanceHistory: true,
        }));
        setLoadingTableDetail(false)
    }, 1000)

    // lịch sử
    const gListContactHistory = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
        const customerCodeDms = row?.customerCodeDms || undefined;
        if (!idCustomer || !customerCodeDms) {
            setContactHistory(undefined)
            pushToast(
                "Không có thông tin chi tiết để hiển thị lịch sử tiếp xúc!",
                "warning"
            );
            return;
        }
        setLoadingTableDetail(true)
        const result = await getListCustomerInteractions(
            idCustomer, customerCodeDms, unitTemp, permittedCategoryCarIds,
            pageSize, pageCurent
        )
        if (result?.status) {
            setContactHistory(result.data)
            setPaginationMap(prev => ({
                ...prev,
                contactHistory: {
                    current: pageCurent,
                    pageSize,
                    total: result.total,
                },
            }));
        } else {
            pushToast(result?.message, "warning")
        }
        // 🔥 QUAN TRỌNG
        setLoadedTabs(prev => ({
            ...prev,
            contactHistory: true,
        }));
        setLoadingTableDetail(false)
    }, 1000)

    //thiếu  tiếp xúc


    const onRowClickVehicleVersionTable = (row?: AppRowCar, rowIndex?: number) => {
        if (!row?.categoryCarId || !permittedCategoryCarIds?.includes(row?.categoryCarId)) {
            return;
        }
        if (!row) {
            // setSelectedId(undefined);
            // setCustomerCodeDms(undefined);
            setRow(undefined);
            return;
        }

        // setSelectedId(row.idCover ? Number(row.idCover) : 0);
        // setCustomerCodeDms(row.customerCodeDms || undefined);
        setRow(row);
    };


    //#endregion

    // #region gọi api lấy data cho chi tiết

    const gInfoVehicleOwnership = async (idCustomer: number, idDetail?: number) => {
        pushLoading(true)
        const result = await getInfoVehicleOwnership(idCustomer, idDetail)
        if (result?.status) {
            setInfoVehicleOwnership(result.data)
            setIsModalUpdateVehicleInformation(true)
        } else {
            pushToast(result?.message, "warning")
        }

        pushLoading(false)
    }
    // #endregion

    const onSaveVisibleFields = useThrottle(async (dataFilterActive: FlattenedField[], dataFilterNoActive: ListField[]) => {
        let result: any;
        const activeFields: FieldsUpdate[] = dataFilterActive.map(item => ({
            fieldId: item.id,
            isActive: 1, // hoặc true tùy bạn muốn mặc định là gì
        }));
        const allFieldsDefaultInactive: FieldsUpdate[] = dataFilterNoActive.flatMap(group =>
            group.fields.map(field => ({
                fieldId: field.id,
                isActive: 0,
            }))
        );
        const listActiveFields = activeFields.concat(allFieldsDefaultInactive)

        switch (activeServiceRecordsTab) {

            case 'invoices': {
                result = await updateFieldUser(id, FIELDTYPE.invoices, undefined, listActiveFields)
                break;
            }
            case 'insurance': {
                result = await updateFieldUser(id, FIELDTYPE.insurance, undefined, listActiveFields)
                break;
            }
            case 'maintenanceHistory': {
                result = await updateFieldUser(id, FIELDTYPE.maintenanceHistory, undefined, listActiveFields)
                break;
            }
            case 'contactHistory': {
                result = await updateFieldUser(id, FIELDTYPE.contactHistoryByOwnedCar, undefined, listActiveFields)
                break;
            }
            default:
                break;
        }

        if (result?.status) {
            pushToast(result?.message, "success")
            setSettingShow(false)

            if (dataFilterActive && dataFilterNoActive) {
                setDataFieldsServiceRecordsActive(prev => ({
                    ...prev,
                    [activeServiceRecordsTab]: dataFilterActive ?? [],
                }));

                setDataFieldsServiceRecordsNoActive(prev => ({
                    ...prev,
                    [activeServiceRecordsTab]: dataFilterNoActive ?? [],
                }));
            }

        } else {
            pushToast(result?.message, "warning")
        }
    }, 2000)

    const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
        switch (activeServiceRecordsTab) {
            case "invoices": {
                gListCustomerInvoices(pageNumber, pageSize)
                break;
            }
            case "insurance": {
                gListCustomerInsurance(pageNumber, pageSize)
                break;
            }
            case "maintenanceHistory": {
                gListCustomerRepair(pageNumber, pageSize)
                break;
            }
            case "contactHistory": {
                gListContactHistory(pageNumber, pageSize)
                break;
            }
            default:
                break;
        }
    }

    const resultFormSubmitUpdateVehicleInformation = (isSucces: boolean, message?: string) => {
        resultFormSubmitOwnedCarOrUsedCar?.(isSucces, message)
        if (isSucces) {
            setSelectedIdTable(selectedIdTable)
            // setSelectedId(selectedId)
        } else {
        }
    }


    useEffect(() => {
        if (!idCustomer) return;

        // setSelectedId(undefined);
        setSelectedIdTable(undefined);
        // setCustomerCodeDms(undefined);
        setRow(undefined);

        setInvoicesInfo([]);
        setInsuranceInfo([]);
        setMaintenanceHistory(undefined);
        setContactHistory(undefined);

        setLoadedTabs({
            invoices: false,
            insurance: false,
            maintenanceHistory: false,
            contactHistory: false,
        });

        setPaginationMap({
            invoices: { current: 1, pageSize: 10, total: 0 },
            insurance: { current: 1, pageSize: 10, total: 0 },
            maintenanceHistory: { current: 1, pageSize: 10, total: 0 },
            contactHistory: { current: 1, pageSize: 10, total: 0 },
        });
    }, [idCustomer]);

    useEffect(() => {
        if (!row) return;

        // reset data theo idCover
        if (row.idCover) {
            setInvoicesInfo([]);
            setInsuranceInfo([]);
            setMaintenanceHistory(undefined);
        }

        // reset data theo customerCodeDms
        if (row.customerCodeDms) {
            setContactHistory(undefined);
        }

        // reset loaded flag
        setLoadedTabs({
            contactHistory: false,
            invoices: false,
            insurance: false,
            maintenanceHistory: false,
        });

    }, [row?.idCover, row?.customerCodeDms]);

    useEffect(() => {
        switch (activeServiceRecordsTab) {
            case "contactHistory":
                // if (!row?.customerCodeDms) {
                //     pushToast(
                //         "Không có thông tin chi tiết để hiển thị lịch sử tiếp xúc!",
                //         "warning"
                //     );
                //     return;
                // }
                if (!row) return;
                if (!currentLoaded) {
                    gListContactHistory();
                }
                break;

            case "invoices":
                if (!row?.idCover) return;
                if (!currentLoaded) {
                    gListCustomerInvoices();
                }
                break;

            case "insurance":
                if (!row?.idCover) return;
                if (!currentLoaded) {
                    gListCustomerInsurance();
                }
                break;

            case "maintenanceHistory":
                if (!row?.idCover) return;
                if (!currentLoaded) {
                    gListCustomerRepair();
                }
                break;
        }
    }, [activeServiceRecordsTab, row?.idCover, row?.customerCodeDms, currentLoaded]);


    return (
        <>
            {
                isSettingShow ?
                    <ServiceRecordFeilds
                        isSettingShow={isSettingShow}
                        recordId={1}
                        type={0}
                        dataFilterActive={dataFieldsServiceRecordsActive[activeServiceRecordsTab]}
                        dataFilterNoActive={dataFieldsServiceRecordsNoActive[activeServiceRecordsTab]}

                        onSaveVisibleFields={onSaveVisibleFields}
                        onClose={() => setSettingShow(false)}
                    /> :
                    null
            }

            <ModalUpdateVehicleInformation
                isOpen={isModalUpdateVehicleInformation}
                idCustomer={idCustomer}
                infoVehicleOwnership={infoVehicleOwnership}
                closeModal={setIsModalUpdateVehicleInformation}
                resultFormSubmit={resultFormSubmitUpdateVehicleInformation}
            />

            <div
                className="custom-page-css border rounded "
                style={{ width: "100%" }}
            >
                <VehicleVersionTable<any>
                    loadingTable={loadingTable}
                    nonDraggableColumnIds={["action"]}
                    nonResizableColumnIds={["action"]}
                    rowClassName={(row) =>
                        (row.data.kind === "group-city" || row.data.kind === "group-role") ? "row-group" : ""
                    }

                    columns={columnsCar}
                    filterColumn={filterColumn}
                    rows={viewRowsCar}
                    dataFilterList={dataFilterList}

                    setDataFilterList={setDataFilterList}
                    onRowClick={onRowClickVehicleVersionTable}

                />
            </div>

            <div
                className="ag-theme-alpine custom-table-ag custom-page-css custom-tabs relative"
                style={{ width: "100%", marginTop: "16px" }}
            // hidden={!selectedIdTable}
            >
                <Tabs
                    activeKey={activeServiceRecordsTab}
                    items={[
                        {
                            key: "invoices",
                            label: (
                                <span className="custom-page-css font-light text-lg">
                                    Thông tin hợp đồng
                                </span>
                            ),
                            children: (
                                <ContactInformation
                                    loadingTableDetail={loadingTableDetail}
                                    dataFieldsActive={dataFieldsServiceRecordsActive.invoices}
                                    pagination={paginationMap.invoices}
                                    data={invoicesInfo}

                                    onPaginationChange={onPaginationChange}
                                />
                            ),
                        },
                        {
                            key: "insurance",
                            label: (
                                <span className="custom-page-css font-light text-lg">
                                    Thông tin bảo hiểm xe
                                </span>
                            ),
                            children: (
                                <WarrantyInformation
                                    loadingTableDetail={loadingTableDetail}

                                    dataFieldsActive={dataFieldsServiceRecordsActive.insurance}
                                    pagination={paginationMap.insurance}
                                    data={insuranceInfo}

                                    onPaginationChange={onPaginationChange}
                                />
                            ),
                        },
                        {
                            key: "maintenanceHistory",
                            label: (
                                <span className="custom-page-css font-light text-lg">
                                    Lịch sử bảo trì bảo dưỡng
                                </span>
                            ),
                            children: (
                                <MaintenanceHistory
                                    loadingTableDetail={loadingTableDetail}
                                    idCustomer={idCustomer}
                                    dataFieldsActive={dataFieldsServiceRecordsActive.maintenanceHistory}
                                    pagination={paginationMap.maintenanceHistory}
                                    data={maintenanceHistory}

                                    onPaginationChange={onPaginationChange}
                                />
                            ),
                        },
                        {
                            key: "contactHistory",
                            label: (
                                <span className="custom-page-css font-light text-lg">
                                    Lịch sử tiếp xúc
                                </span>
                            ),
                            children: (
                                <VehicleContactHistory
                                    loadingTableDetail={loadingTableDetail}

                                    dataFieldsActive={dataFieldsServiceRecordsActive.contactHistory}
                                    pagination={paginationMap.contactHistory}
                                    data={contactHistory}

                                    onPaginationChange={onPaginationChange}
                                />
                            ),
                        }
                    ]}
                    onChange={(k) => setActiveServiceRecordsTab(k as PaginationKey)}
                />
                <div className="custom-page-css absolute top-4 right-2 flex items-center gap-4">
                    <div className='settingCol'>
                        <div className='custom-page-css px-2 py-1 rounded border cursor-pointer '
                            onClick={() => setSettingShow(true)}
                        >
                            <SettingOutlined />
                        </div>
                    </div>

                    {/* {activeServiceRecordsTab === 'insurance' &&
                        <div className="custom-page-css px-2 py-1 rounded border cursor-pointer "
                            onClick={() => setOpenModal(true)}
                        >
                            <PlusCircleOutlined />
                        </div>
                    } */}
                </div>
            </div>

        </>
    );
};
export default OwnedCar;
